module.exports = __webpack_public_path__ + "images/connectbike_small4bb94f5720bc6acb14329da66422e350.png";